import { Stack } from '@mui/material'
import { spacing } from 'c1ui'
import { createRef, FC, ReactNode, useEffect } from 'react'

type DynamicHeightSizerProps = {
    children: ReactNode
    noPadding?: boolean
}

// Makes sure content inside (usually a table) "locks" to the bottom of the screen
export const DynamicHeightSizer: FC<DynamicHeightSizerProps> = ({ children, noPadding = false }) => {
    const ref = createRef<HTMLDivElement>()

    useEffect(() => {
        const distanceFromTop = ref.current?.getBoundingClientRect().top
        ref.current?.style.setProperty('height', `calc(100vh - ${distanceFromTop}px - ${noPadding ? '0px' : spacing.l})`)
    })

    return <Stack ref={ref}>{children}</Stack>
}
